export default {
  inject: {
    sForm: {
      default: '',
    },
    sFormItem: {
      default: '',
    },
  },
  computed: {
    inputDisabled() {
      return this.disabled || (this.sForm || {}).disabled
    },
    validateState() {
      return this.sFormItem ? this.sFormItem.validateState : ''
    },
  },
}
